import React from 'react';
import styled from 'styled-components';
import Chart from 'react-apexcharts';
import { cores, coresGrafico } from '../../../../styles/styleUtils';

const PieChartContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
`;

const PieChartBox = styled.div`
  background-color: ${cores.cinzaClaro};
  border: 1px solid #E2E4E8;
  border-radius: 5px;
  padding: 16px;
  text-align: center;
`;

const PieChartTitle = styled.h4`
  color: ${cores.cinzaMedio};
  font-size: 1rem;
  margin-bottom: 10px;
`;

const PieChartSection = ({ graficos }) => {
  const divisaoReceita = graficos.divisaoReceita;
  const divisaoUnidade = graficos.divisaoUnidade;

  const chartOptions = (labels) => ({
    chart: { type: 'pie' },
    colors: coresGrafico,
    labels,
    legend: { position: 'bottom' },
    tooltip: {
      y: {
        formatter: (val) => `R$ ${val.toFixed(2)}`,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const valor = opts.w.globals.series[opts.seriesIndex];
        const moeda = valor.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        return `${moeda} (${val.toFixed(1)}%)`;
      },
    },
  });

  const receitaLabels = ['Recebidos', 'A Receber'];
  const receitaSeries = [
    divisaoReceita.recebidos,
    divisaoReceita.aReceber,
  ];

  const unidadeLabels = Object.keys(divisaoUnidade);
  const unidadeSeries = unidadeLabels.map((key) => divisaoUnidade[key]);

  return (
    <PieChartContainer>
      <PieChartBox>
        <PieChartTitle>Divisão de Receitas</PieChartTitle>
        {divisaoReceita ? (
          <Chart
            options={chartOptions(receitaLabels)}
            series={receitaSeries}
            type="pie"
            width="100%"
          />
        ) : (
          <p>Carregando...</p>
        )}
      </PieChartBox>

      <PieChartBox>
        <PieChartTitle>Divisão por Unidade</PieChartTitle>
        {divisaoUnidade ? (
          <Chart
            options={chartOptions(unidadeLabels)}
            series={unidadeSeries}
            type="pie"
            width="100%"
          />
        ) : (
          <p>Carregando...</p>
        )}
      </PieChartBox>
    </PieChartContainer>
  );
};

export default PieChartSection;
